import { Component, ViewChild, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'progress-indicator',
  templateUrl: './progress-indicator.component.html',
})
export class ProgressIndicatorComponent implements OnInit {
  progress: number = 0;
  @Input() currentProgress: number = 0;
  @Input() maxProgress: number = 100;
  @ViewChild('maxProgressIndicator') maxProgressIndictor: ElementRef<HTMLElement>;
  @ViewChild('currentProgressIndicator', { static: true }) currentProgressIndicator: ElementRef<HTMLElement>;
  constructor(private renderer: Renderer2) {}
  ngOnInit(): void {
    this.progress = Math.round(((this.currentProgress || 0) / this.maxProgress) * 100);
    this.renderer.setStyle(this.currentProgressIndicator.nativeElement, 'width', `${this.progress}%`);
  }
}
